import { computed, ref } from 'vue'

import { useStoreContacts } from '@/entities/contact'
import { useStoreRooms } from '@/entities/room'


import { Contact } from '@/shared/types/api'
import { Room } from '@/shared/types/store'
import { createPrivateRoom } from '@/shared/utils/im'

const participantProfilePServed = ref<string | null>(null)

export const openParticipantProfileOverlay = (contact: Contact) => {
  if (!contact.imLogin) {
    return
  }
  participantProfilePServed.value = contact.imLogin
}

export const closeParticipantProfileOverlay = () => {
  participantProfilePServed.value = null
}

export const useParticipantProfileOverlay = () => {
  const storeRooms = useStoreRooms()
  const { findByPServed } = useStoreContacts()

  const overlayRoom = computed<Room | null>(() => {
    const pServed = participantProfilePServed.value
    if (!pServed) {
      return null
    }

    const existing = storeRooms.findByPServed(pServed)
    if (existing && !existing.isGroup) {
      return existing
    }

    const contact = findByPServed(pServed)
    if (!contact?.imLogin) {
      return null
    }

    return createPrivateRoom(contact.imLogin, contact)
  })

  const isOpen = computed(() => Boolean(participantProfilePServed.value && overlayRoom.value))

  return {
    overlayRoom,
    isOpen,
    open: openParticipantProfileOverlay,
    close: closeParticipantProfileOverlay,
  }
}
